import { highlight } from "prismjs";

export default {
  prod_P2ifYcgHeS61f8: {
      name: 'descriptions.meteredName',
      description: 'descriptions.metered',
      marketingFeatures: ['marketingFeatures.unlimitedPerMo', 'marketingFeatures.unlimitedConcurrency'],
      features: [
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.conditions', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.forum', enabled: true },
        { text: 'features.geocoding', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkonly', enabled: true },
        { text: 'features.subhourly', enabled: true , highlight: true},
      ],
    },
   
    prod_P2iEHuaJlboQ6r: {
      name: 'descriptions.professionalName',
      description: 'descriptions.professional',
      marketingFeatures: ['marketingFeatures.tenMPerMo', 'marketingFeatures.singleConcurrency'],
      features: [
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.conditions', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.forum', enabled: true },
        { text: 'features.geocoding', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkschedule', enabled: true, highlight: true },
      ],
    },
    
    prod_P2if4Ek3zDY54r: {
      name: 'descriptions.corporateName',
      description: 'descriptions.corporate',
      marketingFeatures: ['marketingFeatures.unlimitedPerMo', 'marketingFeatures.teamConcurrency'],
      features: [
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.conditions', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.email', enabled: true , highlight: true},
        { text: 'features.geocoding', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkschedule', enabled: true },
        { text: 'features.subhourly', enabled: true },
        { text: 'features.tenusers', enabled: true , highlight: true },
        { text: 'features.degreedays', enabled: true, highlight: true },
        { text: 'features.energyelements', enabled: true , highlight: true },
        { text: 'features.agelements', enabled: true , highlight: true },
        { text: 'features.marine', enabled: true, highlight: true },
        { text: 'features.noattribution', enabled: true, highlight: true },
      ],
    },
    prod_enterprise: {
      name: 'descriptions.enterpriseName',
      description: 'descriptions.enterprise',
      marketingFeatures: ['marketingFeatures.unlimitedPerMo', 'marketingFeatures.customConcurrency'],
      features: [
        { text: 'features.history', enabled: true },
        { text: 'features.forecast', enabled: true },
        { text: 'features.conditions', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.api', enabled: true },
        { text: 'features.email', enabled: true , highlight: true},
        { text: 'features.geocoding', enabled: true },
        { text: 'features.alerts', enabled: true },
        { text: 'features.astronomy', enabled: true },
        { text: 'features.bulkschedule', enabled: true },
        { text: 'features.subhourly', enabled: true },
        { text: 'features.unlimitedusers', enabled: true , highlight: true},
        { text: 'features.degreedays', enabled: true },
        { text: 'features.energyelements', enabled: true },
        { text: 'features.agelements', enabled: true },
        { text: 'features.marine', enabled: true },
        { text: 'features.noattribution', enabled: true },
        { text: 'features.sla', enabled: true , highlight: true},
        { text: 'features.invoice', enabled: true , highlight: true},

      ],
    },
    prod_NJWuAMntHzcYWM: {
      name: 'descriptions.histFcstName',
      description: 'descriptions.histFcst',
      marketingFeatures: [],
      features: [
        { text: 'features.yearsavailable', enabled: true },
        { text: 'features.fullforecast', enabled: true },
        { text: 'features.coverage', enabled: true },
        { text: 'features.customdays', enabled: true },
      ],
    },

    prod_weathermaps: {
      name: 'descriptions.weatherMapsName',
      description: 'descriptions.weatherMaps',
      marketingFeatures: [],
      features: [
        { text: 'features.multiplelayers', enabled: true },
        { text: 'features.radarlayers', enabled: true },
        { text: 'features.preciptotals', enabled: true },
        { text: 'features.easyintegrate', enabled: true },
      ],
    },

    prod_weatherStats: {
      name: 'descriptions.weatherStatsName',
      description: 'descriptions.weatherStats',
      marketingFeatures: [],
      features: [
        { text: 'features.historysummaries', enabled: true },
        { text: 'features.frostdates', enabled: true },
        { text: 'features.customfiltering', enabled: true },
        { text: 'features.areaagg', enabled: true },
      ],
    },
  };
  